module.exports = __webpack_public_path__ + "static/header-background.21244ba7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/assets/header-background.jpg
// module id = 984
// module chunks = 114276838955818